import styled from 'styled-components';
import { lightTheme } from '../../styles/theme';

export const Flag = styled.div`
	width: 20px;
	height: 20px;

	img {
		border-radius: 999px;
		width: 100%;
		height: 100%;
		object-fit: cover;
	}
`;

export const Wrapper = styled.div`
	position: relative;
	width: fit-content;
	width: 135px;
`;

export const Box = styled.div<{ small?: boolean }>`
	position: relative;
	z-index: 1;
	height: ${({ small }) => (small ? '40px' : '44px')};
	border-radius: ${({ small }) => (small ? '8px' : '12px')};
	padding: 12px 16px;
	display: flex;
	align-items: center;
	justify-content: space-between;
	background: ${lightTheme.select.background};
	box-shadow: 0px 4px 6px -1px rgba(0, 0, 0, 0.1),
		0px 2px 4px -1px rgba(0, 0, 0, 0.06);
	cursor: pointer;

	> div {
		display: flex;
		align-items: center;
		justify-content: space-between;

		> p {
			margin-left: 8px;
			font-size: 14px;
			font-weight: 500;
			color: ${lightTheme.select.label};
		}
	}

	> p {
		margin-left: 8px;
	}
`;

export const Options = styled.div<{
	$isOpen: boolean;
	customHeight?: number;
	showOnTop?: boolean;
}>`
	position: absolute;
	width: 155px;
	z-index: 1;
	background: ${lightTheme.select.background};
	margin-top: 8px;
	padding: 2px;
	border-radius: 12px;
	box-shadow: 0px 10px 15px -3px rgba(0, 0, 0, 0.1),
		0px 4px 6px -2px rgba(0, 0, 0, 0.05);
	display: ${({ $isOpen }) => ($isOpen ? 'block' : 'none')};
	height: ${({ customHeight }) =>
		customHeight ? customHeight + 'px' : 'auto'};
	overflow-y: ${({ customHeight }) => (customHeight ? 'scroll' : 'none')};
	overflow-x: ${({ customHeight }) => (customHeight ? 'hidden' : 'none')};
	transform: ${({ showOnTop }) => showOnTop && 'translateY(-275px)'};
`;

export const Option = styled.div<{
	disabled: boolean;
	isSelected?: boolean;
	small?: boolean;
}>`
	display: flex;
	justify-content: space-between;
	align-items: center;
	padding: 12px 16px;
	border-radius: 12px;
	margin-top: 1px;
	transition: 0.1s;
	background: ${({ disabled, isSelected }) =>
		disabled
			? lightTheme.select.disabledBackground
			: isSelected
			? lightTheme.select.activeBackground
			: 'white'};

	&:not(:hover) {
		transition-delay: 0.05s;
	}

	> div {
		display: flex;
	}

	p {
		font-weight: 500;
		margin-left: 8px;
		color: ${({ disabled }) =>
			disabled ? lightTheme.select.disabledLabel : lightTheme.select.label};
		font-size: 14px;
	}

	i {
		color: ${({ disabled }) =>
			disabled ? lightTheme.select.disabledLabel : lightTheme.select.label};
		font-size: 14px;
	}

	&:hover {
		background: ${({ disabled }) =>
			disabled
				? lightTheme.select.disabledBackground
				: lightTheme.select.activeBackground};
		cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'pointer')};
		transform: ${({ disabled, small }) =>
			disabled
				? 'scale(1)'
				: small
				? 'scale(1.02) translateX(3px)'
				: 'scale(1.12) translateX(10px)'};
	}
`;
